import numeral from "numeral";

export const money = (value) => numeral(value ?? 0).format("0,0");

export const formatNumberToDisplay = (num = 0, currency = "") => {
  num = Number(num) || 0;

  if (Number.isInteger(num)) {
    return num.toLocaleString("en-US") + currency;
  }

  const numStr = num.toString();
  const decimalPart = numStr.split(".")[1] || "";

  if (decimalPart.length > 4) {
    let roundedStr = num.toFixed(4);

    roundedStr = roundedStr.replace(/\.?0+$/, "");

    return (
      Number(roundedStr).toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      }) + currency
    );
  } else {
    return (
      num.toLocaleString("en-US", {
        minimumFractionDigits: decimalPart.length,
        maximumFractionDigits: decimalPart.length,
      }) + currency
    );
  }
};
